export enum EAccessIds {
    ACCESS_POINTS = 'access-points',
    ACCESS_ADVERTISEMENT = 'access-advertisement',
    ACCESS_CONTROL = 'access-control',
    ACCESS_ENTRY = 'entry-messages',
    ACCESS_EXIT = 'exit-messages',
    ACCESS_EXPIRATION = 'expiration-messages',
    ACCESS_SUBSCRIPTION = 'subscription-status',
    ACCESS_ATTENTION = 'alert-messages',
    ACCESS_GROUPS = 'access-groups',
};

export const accessPageFragments = [
    {
        title: 'SETTINGS.ACCESS.EDGES.SUMMARY_LABEL',
        id: EAccessIds.ACCESS_POINTS,
    },
    {
        title: 'SETTINGS.ACCESS.ADVERTISEMENT',
        id: EAccessIds.ACCESS_ADVERTISEMENT,
    },
    {
        title: 'SETTINGS.ACCESS.CONTROL',
        id: EAccessIds.ACCESS_CONTROL,
    },
    {
        title: 'SETTINGS.ACCESS.ENTRY',
        id: EAccessIds.ACCESS_ENTRY,
    },
    {
        title: 'SETTINGS.ACCESS.LEAVE',
        id: EAccessIds.ACCESS_EXIT,
    },
    {
        title: 'SETTINGS.ACCESS.MATURITY',
        id: EAccessIds.ACCESS_EXPIRATION,
    },
    {
        title: 'SETTINGS.ACCESS.SIGNATURE',
        id: EAccessIds.ACCESS_SUBSCRIPTION,
    },
    {
        title: 'SETTINGS.ACCESS.ATTENTION',
        id: EAccessIds.ACCESS_ATTENTION,
    },
    // {
    //   title: 'SETTINGS.ACCESS.ACCESS_GROUPS',
    //   id: EAccessIds.ACCESS_GROUPS,
    // }
];